// Meta Pixel ID
const PIXEL_ID = '919279253799008'

// Extend Window type for fbq
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: unknown
  }
}

// Inject the Meta Pixel script into <head>
export function initMetaPixel(): void {
  if (typeof window === 'undefined') return
  if (window.fbq)
    return // already initialized
    // Inline pixel bootstrap
  ;(function (
    f: Window & typeof globalThis,
    b: Document,
    e: string,
    v: string,
  ) {
    const n: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue: unknown[]
      loaded: boolean
      version: string
      push?: unknown
    } = function (...args: unknown[]) {
      if (n.callMethod) {
        n.callMethod(...args)
      } else {
        n.queue.push(args)
      }
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    f.fbq = n

    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    b.head.appendChild(t)
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  window.fbq('init', PIXEL_ID)
}

// Fire a standard or custom event
export function trackEvent(
  event: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined' || !window.fbq) return
  if (params) {
    window.fbq('track', event, params)
  } else {
    window.fbq('track', event)
  }
}
